/* eslint-disable */
import * as Types from './schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const BookingDocument = gql`
    query Booking($page: Int, $search: String, $order: Order, $sortField: ReservationSortField, $perPage: Int) {
  user {
    id
    reservations(
      search: $search
      sortField: $sortField
      order: $order
      page: $page
      perPage: $perPage
    ) {
      items {
        id
        uuid
        calendarIcsUrl
        calendarGoogleUrl
        restaurant {
          id
          name
          link
          slug
          logo
          fullAddress
          address
          utcOffsetMinutes
          workSchedulesFormated {
            dayNumber
            dayName
            workingHour
          }
          types {
            id
            name
          }
          cuisines {
            id
            name
          }
        }
        customPlace {
          name
          location
          country {
            id
            name
            isoCode
          }
        }
        reservationAt(format: "Y-m-d H:i:s")
        flexibility
        guestsCount
        comment
        moderatorComment
        status
        createdAt(format: "Y-m-d H:i:s")
        updatedAt(format: "Y-m-d H:i:s")
        isPremium
      }
      currentPage
      itemsPerPage
      pageCount
      totalCount
    }
  }
}
    `;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      order: // value for 'order'
 *      sortField: // value for 'sortField'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useBookingQuery(baseOptions?: Apollo.QueryHookOptions<BookingQuery, BookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export function useBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingSuspenseQueryHookResult = ReturnType<typeof useBookingSuspenseQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const CancelReservationDocument = gql`
    mutation cancelReservation($uuid: Uuid!) {
  cancelReservation(uuid: $uuid)
}
    `;
export type CancelReservationMutationFn = Apollo.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, options);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = Apollo.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = Apollo.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export type BookingQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Types.Order>;
  sortField?: Types.InputMaybe<Types.ReservationSortField>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BookingQuery = { __typename?: 'Query', user: { __typename?: 'UserProxyType', id: number, reservations: { __typename?: 'ReservationPaginatedType', currentPage?: number | null, itemsPerPage?: number | null, pageCount?: number | null, totalCount?: number | null, items?: Array<{ __typename?: 'ReservationType', id: number, uuid: any, calendarIcsUrl: string, calendarGoogleUrl?: string | null, reservationAt: string, flexibility: Types.ReservationFlexibility, guestsCount: number, comment?: string | null, moderatorComment?: string | null, status: Types.ReservationStatus, createdAt: string, updatedAt: string, isPremium: boolean, restaurant?: { __typename?: 'RestaurantType', id: number, name: string, link: string, slug: string, logo: string, fullAddress: string, address: string, utcOffsetMinutes: number, workSchedulesFormated: Array<{ __typename?: 'WorkScheduleFormatedType', dayNumber: number, dayName: string, workingHour: Array<string> }>, types: Array<{ __typename?: 'RestaurantTypeType', id: number, name: string }>, cuisines: Array<{ __typename?: 'RestaurantCuisineType', id: number, name: string }> } | null, customPlace?: { __typename?: 'CustomPlaceType', name: string, location: string, country: { __typename?: 'CountryProxyType', id: number, name: string, isoCode: string } } | null }> | null } } };

export type CancelReservationMutationVariables = Types.Exact<{
  uuid: Types.Scalars['Uuid']['input'];
}>;


export type CancelReservationMutation = { __typename?: 'Mutation', cancelReservation: boolean };
